import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 52;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    landscape: {
      baseWidth: width,
      baseHeight: height,
      scaleCoeff: {
        scale: 1.5,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(-70),
        y: convertToPercentageY(114 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(90),
        y: convertToPercentageY(186 + yOffset),
        duration: 170,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    landscape: {
      scaleCoeff: {
        scaleX: 3,
        scaleY: 2,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(165),
        y: convertToPercentageY(277),
        alpha: 0,
        angle: -45,
        scale: 0.15,
      },
      {
        wait: 400,
      },
      {
        x: convertToPercentageX(208),
        y: convertToPercentageY(356),
        alpha: 1,
        angle: 76,
        scale: 0.36,
        duration: 67,
      },
      {
        x: convertToPercentageX(307),
        y: convertToPercentageY(539),
        angle: 45,
        scale: 0.87,
        duration: 166,
      },
      {
        angle: 90,
        scale: 2.52,
        duration: 166,
      },
      {
        scale: 2.7,
        duration: 67,
      },
    ],
  },
];
